import React, { useContext } from 'react';
import { Alert, AlertIcon } from '@chakra-ui/react';
import profileForm from 'base/defaults/forms/profile.json';

import { ProfileContext } from 'core/services/store/profile/store';
import ProfileServices from 'core/services/store/profile/services';
import * as ProfileActions from 'core/services/store/profile/actions';
import GlobalFormComponent from 'core/components/forms/GlobalFormComponent';

const ProfileForm = () => {
  const [state, dispatch] = useContext(ProfileContext);
  const profile = state.profile;
  const services = ProfileServices(dispatch, ProfileActions);

  const onSubmit = (value) => {
    services.updateProfile({
      id: profile.id,
      ...value,
    });
  };

  return (
    <>
      <GlobalFormComponent formFields={profileForm} formStateType={profile} onSubmit={onSubmit} />
      {state.success && (
        <Alert status="success">
          <AlertIcon />
          Your profile has been updated
        </Alert>
      )}
    </>
  );
};

export default {
  $: 'Stack',
  props: {
    direction: 'column',
    spacing: 5,
  },
  children: [
    {
      component: ProfileForm,
    },
  ],
};
